<template>
    <vs-button class="mg-btn-gold" color="primary" text-color="whiteprimary"  v-on:click="modalOpen">Add Response</vs-button>    
    <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#TicketModals" id="addTicketBtn"> </button>             
    <div class="modal fade right" id="TicketModals" tabindex="-1" style="display: none;" aria-hidden="true"  data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="staticBackdropLabel">
        <div class="modal-dialog modal-dialog-centered">            
            <div class="modal-content">
                <div class="modal-header">
                    <input type="hidden" name="ticketValId" id="ticketValId">
                    <h5 class="modal-title">Add Response</h5> 
                    <button type="button" class="btn-close" id="closePop" data-bs-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                <form @submit.prevent="onSubmit" class="ticketFrm" id="ticketFrm"  enctype="multipart/form-data" >
                    <div class="modal-body setformbackform">
                        <div class="row">
                            <div class="col-sm-12">
                                <span v-if="errorMessage != ''">
                                    <p class="alert alert-danger error-msg" >{{ errorMessage }}</p>
                                </span>
                            </div>
                        </div> 
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="formmginput-controlx mb-2"> 
                                    <label for="textarea" class="form-label">Response</label> 
                                    <textarea name="issue" v-model="v$.form.issue.$model" class="form-control" placeholder="Enter issue" v-on:keyup="textareaFun" id="textarea"/>
                                    <div class="input-errors" v-for="(error, index) of v$.form.issue.$errors" :key="index">
                                        <div class="error-msg">{{ error.$message }}</div>
                                    </div>
                                </div> 
                            </div>
                            <div class="col-sm-12">
                                <file-pond
                                    name="file"
                                    v-model="file"
                                    ref="pond"
                                    label-idle="Drop files here..."
                                    v-bind:allow-multiple="true"
                                    accepted-file-types="image/jpeg, image/png, application/pdf, application/zip"
                                    instantUpload=false
                                    max-files="5"
                                    v-bind:files="myFiles"
                                    @updatefiles="updateFiles"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">                           
                        <button type="button" class="mg-btn-gold" id="saveUpdateBtn" :disabled="v$.form.$invalid" v-on:click="addTicket" v-if="formLoader === 1">{{ buttonName }}</button>
                        <button type="button" class="mg-btn-gold" id="saveUpdateBtn" :disabled="v$.form.$invalid" v-else><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Loading...</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import useVuelidate from '@vuelidate/core'
import $ from "jquery";
import {
    required,
    minLength
} from '@vuelidate/validators'
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview
);
export default {
    name: 'AddResponsePage',
    emits: ['reloadTableData'], 
    components: {
        // Select2,
        FilePond
    },
    data() {
        return {
            img_url: process.env.VUE_APP_IMG_URL,
            modalType: 'Add',
            buttonName: 'Save',
            errorMessage: '',
            formLoader: 1,
            logoFile: null,
            file: [], // Holds uploaded files
                files: [],
                myFiles: [],
            form: {
                issue: '',
            },
        }
    },
    methods: {
        startLoader () {
            this.$Progress.start()
        },
        finishLoader () {
            this.$Progress.finish()
        },
        textareaFun() {
            var textarea = document.getElementById("textarea");
            textarea.style.height = "";
            textarea.style.height = Math.min(textarea.scrollHeight, 200) + "px";
        },
        updateFiles(newFiles) {            
            this.files = newFiles.map((file) => file.file);
        },
        async modalOpen() {
            this.errorMessage = ''
            this.form.issue = '';
            this.isNewImg = 0;
            this.modalType = 'Add';
            this.buttonName = 'Save',
            this.logoFile = null,
            this.files = []
            this.$nextTick(() => {
            if (this.$refs.pond) {
                this.$refs.pond.removeFiles();
                }
            });
            this.v$.$reset()
            document.getElementById('ticketValId').value = '';
            document.getElementById('addTicketBtn').click();
            setTimeout(async () =>
                $("#textarea").focus(),
            500);
        },
        async addTicket() {
            this.formLoader = 2
            let _URL = ''
            
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;

            _URL = process.env.VUE_APP_API_URL + 'ticket-response/create'
            const fd = new FormData;
            fd.append('response_id', $('#ticketId').val())
            fd.append('response_desc', this.form.issue)
            this.files.forEach((file) => {
                fd.append("files", file);
            });
            this.startLoader()
            await axios.post(_URL, fd)
            .then((resp) => {
                if (resp.status == 200 && resp.data.status == 'success') {
                    document.getElementById('closePop').click();
                    this.$toast.success(resp.data.message);
                    this.$emit('reload-table-data');
                } else if (resp.status == 200 && resp.data.status == 'failure') {
                    this.errorMessage = resp.data.message;
                }
                    this.formLoader = 1
                    this.finishLoader()
            })
            .catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
                console.log("response", error.response.status);
                console.log("message", error.response.data.message);
                this.errorRes = error.response.data.message;
                this.formLoader = 1
            })            
        },
    },
    setup() {
        return {
            v$: useVuelidate()
        }
    },
    validations() {
        return {
            form: {
                issue: {
                    min: minLength(2),
                    required,
                }
            },
        }
    },

}
</script>
<style scoped>
.img-thumbnail{
    width: 100px;
    height: 100px;
}
</style>